import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export default function ErrorFallback({ error, resetError }) {
  const { t } = useTranslation('common');

  return (
    <div className="flex items-center justify-center min-h-screen p-4">
      <Card className="max-w-md w-full">
        <CardHeader>
          <div className="flex items-center gap-3">
            <div className="flex size-10 items-center justify-center rounded-full bg-destructive/10 text-destructive">
              <AlertTriangle className="size-5" />
            </div>
            <CardTitle>{t('error', 'Something went wrong')}</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            {error?.message || t('error_description', 'An unexpected error occurred. Please try again.')}
          </p>
        </CardContent>
        <CardFooter>
          <Button onClick={resetError} className="w-full">
            {t('retry', 'Try again')}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
